import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiChatGet, apiFaqsGet } from '@/entities/support/modules/api/support';

export const useFaqs = (enabled = true) =>
  useFetch({
    api: apiFaqsGet,
    keywords: queryKeys.support.faqs,
    enabled,
    staleTime: 5 * 60 * 1000,
  });

export const useChat = (enabled = true) =>
  useFetch({
    api: apiChatGet,
    keywords: queryKeys.support.chat,
    enabled,
    staleTime: 0,
  });
